/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestItemsSchema } from "./banquetCreateRequestItemsSchema.ts";
import { notificationLevelEnumSchema } from "./notificationLevelEnumSchema.ts";

export const sendDeviceAlertRequestSchema = z.object({
	notification_level: notificationLevelEnumSchema.describe(
		"* `Error` - Ошибка\n* `Timeout` - Tаймаут\n* `Warning` - Предупреждение\n* `Critical` - Критическая ошибка",
	),
	data: banquetCreateRequestItemsSchema,
	timestamp: z.iso.datetime(),
});
